// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"782":"70d223dd","889":"230c36c7"}[chunkId] + ".css";
};